
<modal v-if="modalStateFor(modalId).isVisible" :state="modalStateFor(modalId)" :index="index" @toggle-modal="reset">
  <h4 class="modal-title">Document Quick Jump</h4>
  <input
    id="quick-jump-search"
    type="text"
    v-model="searchInput"
    v-on:keyup.enter="submit"
    v-on:keydown.down="handleDown"
    v-on:keydown.up="handleUp"
    ref="quickJumpInput"
  />
  <scroll-area>
    <ul class="list-group">
      <li :class="liClass(index)" v-for="(item, index) in results" :key="item.id">
        <a :style="getColor(item)" :href="item.link"><icon :class="getIcon(item)"></icon> {{ item.title }}</a>
      </li>
    </ul>
  </scroll-area>
</modal>
